import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';


@Injectable({ providedIn: 'root' })
export class EfilingService {
  private customStepsSubject = new Subject<any>();
  customStepsObservable = this.customStepsSubject.asObservable();
  constructor(
    private httpClient: HttpClient
  ) { }

  downloadFile(url: string): Observable<Blob> {
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getdownloadAllDocuments(path: string) {
    return this.httpClient.get(path).pipe(
      map((response: any) => {
        if (response && (response.status === 200 || response.status === 204)) {
          return response;
        }
      })
    );
  }
  getEfilingVersionStatus(visatype: string) {
    return this.httpClient.get(`/efiling/${visatype}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response && (response.status === 200 || response.status === 204)) {
          return response;
        }
      })
    );
  }

}
